<template>
  <div>
    <van-swipe :loop="true" touchable class="my-swipe" :height="200" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img style="width: 100%;height: 100%" v-lazy="image" @click="imgShow(index)"/>
      </van-swipe-item>
    </van-swipe>

    <van-divider/>

    <van-grid v-if="stuShow" style="margin: 10px">
      <van-grid-item to="select" icon="http://icon.hhstu.club/course3.png"
                     text="课程选择"/>
      <van-grid-item to="ClubSelect" icon="http://icon.hhstu.club/club.png"
                     text="体育俱乐部"/>
      <van-grid-item to="VenueBooking" icon="http://icon.hhstu.club/yuyue.png"
                     text="场馆预约"/>
      <van-grid-item to="more" icon="https://img.coolcr.cn/2021/01/24/7ea8a6c9d1ba8.png"
                     text="更多"/>
    </van-grid>

    <van-grid v-if="adminShow" style="margin: 10px">
      <van-grid-item to="course" icon="http://icon.hhstu.club/course3.png"
                     text="课程管理"/>
      <van-grid-item to="teachers" icon="http://icon.hhstu.club/%E6%95%99%E5%B8%88%E8%8A%82.png"
                     text="教师管理"/>
      <van-grid-item to="student" icon="http://icon.hhstu.club/%E5%AD%A6%E7%94%9F.png"
                     text="学生管理"/>
      <van-grid-item to="club" icon="http://icon.hhstu.club/club.png"
                     text="俱乐部管理"/>
      <van-grid-item to="VenueManage" icon="http://icon.hhstu.club/yuyue.png"
                     text="场馆管理"/>
      <van-grid-item to="music" icon="http://icon.hhstu.club/%E9%9F%B3%E4%B9%90.png"
                     text="音乐"/>
      <van-grid-item to="news" icon="http://icon.hhstu.club/%E6%96%B0%E9%97%BB.png"
                     text="通知和资讯"/>
      <van-grid-item to="more" icon="http://icon.hhstu.club/%E5%85%B6%E4%BB%96.png"
                     text="更多"/>
    </van-grid>

    <van-grid v-if="teaShow" style="margin-top: 10px">

      <van-grid-item to="course" icon="http://icon.hhstu.club/course3.png"
                     text="课程管理"/>
      <van-grid-item to="club" icon="http://icon.hhstu.club/club.png"
                     text="俱乐部管理"/>
      <van-grid-item to="VenueManage" icon="http://icon.hhstu.club/yuyue.png"
                     text="场馆管理"/>
      <van-grid-item to="more" icon="http://icon.hhstu.club/%E5%85%B6%E4%BB%96.png"
                     text="更多"/>
    </van-grid>

    <van-divider/>

    <van-sticky>
      <h3 style="color: black;margin: 5px 5px 5px 20px;">通知资讯
        <van-icon name="volume"/>
      </h3>

      <van-divider/>
      <van-cell-group v-for="item in news" :key="item.id">

        <van-cell :key="item.id" v-if="item.ntype===1"
                  :label="new Date(parseInt(item.utime)).toLocaleString()" @click="viewNews1(item)">
          <template #title>
            <span class="custom-title">{{ item.title }}</span>
            <van-tag type="primary ">通知</van-tag>
          </template>
        </van-cell>
        <van-cell :key="item.id" v-if="item.ntype===2"
                  :label="new Date(parseInt(item.utime)).toLocaleString()" is-link :url="item.src">
          <template #title>
            <span class="custom-title">{{ item.title }}</span>
            <van-tag type="danger">资讯</van-tag>
          </template>
        </van-cell>
      </van-cell-group>

      <div style="margin-bottom: 44px"></div>
    </van-sticky>

    <van-action-sheet v-model="news1Show" :title="title">

      <div
        style="word-wrap: break-word;word-break: break-all;overflow: hidden;width: 100%; padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">
        {{ content }}
      </div>
    </van-action-sheet>

  </div>
</template>

<script>

import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {
  Col, Row, Swipe, SwipeItem, Grid, GridItem, Lazyload,
  Empty, ShareSheet, Toast, Dialog, Image, Divider, Button,
  Tab, Tabs, Sticky, Cell, Card, ActionSheet, ImagePreview,
  Tag, CellGroup, Icon, Form, Picker, Popup, Field
} from 'vant';


Vue.use(Col);
Vue.use(Row);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Empty);
Vue.use(Lazyload);
Vue.use(ShareSheet);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Image);
Vue.use(Divider);
Vue.use(Button);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Sticky);
Vue.use(Cell);
Vue.use(Card);
Vue.use(ActionSheet);
Vue.use(ImagePreview);
Vue.use(Tag);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Field);
import {GetNewsListByType, GetNewsById, GetSwiperList} from "@/network/news";

export default {
  name: "Home",
  components: {
    NavBar,
  },
  data() {
    return {
      //swiper
      images: [
        // require('../../assets/img/home/join_us.png'),
        // require('../../assets/img/home/sport_training_center.jpg'),
        // require('../../assets/img/home/sport_training_2.jpg'),
        // require('../../assets/img/home/sport_training_3.jpg'),
        // require('../../assets/img/home/sport_training_4.jpg'),
        // 'http://cdn.sport.hhstu.xyz/societies_lb1.png',
        // 'http://cdn.sport.hhstu.xyz/societies_lb2.png',
        // 'http://cdn.sport.hhstu.xyz/eleme_title1.jpg',
        // 'http://cdn.sport.hhstu.xyz/join_us.png',
        // require('../../assets/img/home/sport_training_1.jpg'),
        'https://img1.baidu.com/it/u=722430420,1974228945&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500',
      ],

      news: [],

      //action sheet
      news1Show: false,
      title: "",
      content: "",


    }
  },
  activated() {
    this.getNews();
    // this.getSwiperList();
  },
  computed: {
    stuShow() {
      return this.$cookies.get("user") === "student"
    },
    teaShow() {
      return this.$cookies.get("user") === "teacher"
    },
    adminShow() {
      return this.$cookies.get("user") === "admin"
    }
  },
  methods: {
    getNews() {
      GetNewsListByType(3).then(res => {
        this.news = [];
        this.news = res;
      })
    },
    getSwiperList() {
      GetSwiperList().then(res => {
        this.images = [];
        res.map(v => {
          this.images.push(v.image)
        })
      })
    },
    viewNews1(item) {
      GetNewsById(item.id).then(res => {
        this.content = res.content;
      })
      this.title = item.title;
      this.news1Show = true;
    },
    imgShow(index) {
      // console.log(index);
      ImagePreview({
        images: this.images,
        closeable: true,
        startPosition: index,
      });
    },
  }

}
</script>

<style scoped>

/*.home-nav {*/
/*  !*background-color: var(--color-tint);*!*/
/*  !*background-image: linear-gradient(#e66465, #9198e5);*!*/


/*  !* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ *!*/
/*  background: #ee9ca7; !* fallback for old browsers *!*/
/*  background: -webkit-linear-gradient(to right, rgb(238, 156, 167), rgb(255, 221, 225));*/
/*  !* Chrome 10-25, Safari 5.1-6 *!*/
/*  background: linear-gradient(to right, rgb(238, 156, 167), rgb(255, 221, 225));*/
/*  !* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ *!*/
/*  color: #fff;*/

/*  !*在使用浏览器原生滚动时，为了让导航不跟随一起滚动*!*/
/*  !*position: fixed;*!*/
/*  !*left: 0;*!*/
/*  !*right: 0;*!*/
/*  !*top: 0;*!*/
/*  !*z-index: 9;*!*/
/*}*/
.home-nav {
  background-image: linear-gradient(135deg, #C2FFD8 10%, #465EFB 100%);
}

.content {
  padding: 16px 16px 160px;
}


</style>
